import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class OrganizationProductsService {
    static getInstance() {
        if (!OrganizationProductsService.instance) {
            OrganizationProductsService.instance = new OrganizationProductsService();
        }

        return OrganizationProductsService.instance;
    }

    async list(params = {}) {
        const response = await axios.get(`${API_BASE_URL}/organization/products`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data?.data || null;
    }
}
